import { propertyTypeLabels } from './Commercial/LeverageLimits/RuralPropertyLeverageLimit'

export const TierTypes = { cities: 'City Tiers', counties: 'County Tiers', msa: 'MSA Tiers' }

export const ProgramTypes = {
  BEYOND_PRIME: 'Beyond Prime',
  BEYOND_PRIME_INVESTOR: 'Beyond Prime Investor',
  COMMERCIAL_ONLY_PROGRAMMED: 'Commercial Only Programmed',
  MULTIFLOW: 'MultiFlow',
  FAST_MONEY: 'FastMoney',
  HARD_MONEY: 'HardMoney',
  SOFT_MONEY: 'SoftMoney',
  COMMERCIAL_DSCR: 'CommercialDSCR',
}

export const citizenshipLabels: Record<string, string> = {
  UsCitizen: 'US Citizen',
  PermanentResidentAlien: 'Permanent Resident',
  NonPermanentResidentAlien: 'Non Permanent Resident',
  ForeignNational: 'Foreign National',
  ITIN: 'ITIN',
}

export const RehabBudgetTypesLabel: Record<string, string> = {
  light: 'Light Rehab',
  standard: 'Standard Rehab',
  heavy: 'Heavy Rehab',
}

export enum CommercialProductTypes {
  BRIDGE = 'Bridge',
  FIX_AND_FLIP = 'FixAndFlip',
  GROUND_UP_CONSTRUCTION = 'GroundUpConstruction',
  DSCR = 'DSCR',
  NON_QM = 'NonQM',
}

export const borrowerTypes: string[] = ['LLC', 'LLP', 'Corp', 'Partnership', 'Revocable Trust', 'Individual']

export enum RatePriceAdjustmentKeys {
  MAX_ADJUSTMENT = 'maxAdjustment',
  LOAN_PURPOSE = 'loanPurpose',
  LOAN_AMOUNT = 'loanAmount',
  LOAN_TERM = 'loanTerm',
  EXPERIENCE = 'experience',
  AIV_LTV = 'aivLtv',
  LTC = 'ltc',
  CLTV = 'cltv',
  FICO = 'fico',
  MONTHS_RESERVE = 'monthsReserve',
  BANKRUPTCY = 'bankruptcy',
  FORECLOSURE = 'foreclosure',
  SHORT_SALE = 'shortSale',
  DEED_IN_LIEU = 'deedInLieu',
  FORBEARANCE = 'forbearance',
  MORTGAGE_LATES = 'mortgageLates',
  OCCUPANCY = 'occupancy',
  PROPERTY_TYPE = 'propertyType',
  STATE = 'state',
  CITIZENSHIP = 'citizenship',
  REHAB_BUDGET_TYPE = 'rehabBudgetType',
}

export interface IRehabBudgetTypeOption1 {
  lightRate: number
  lightTo: number
  standardRate: number
  standardFrom: number
  standardTo: number
  heavyRate: number
  heavyFrom: number
}

export interface IRehabBudgetTypeOption2 {
  lightRate: number
  lightTo: number
  heavyRateFrom: number
  heavyRateTo: number
  heavyFrom: number
  heavyArvFrom: number
}

export interface IRehabBudgetTypeOption3 {
  lightRate: number
  heavyRateFrom: number
  heavyRateTo: number
  heavyArvFrom: number
}

export interface IRehabBudgetTypeOption4 {
  lightRate: number
  heavyRate: number
}

export interface IRehabBudgetTypeOption5 {
  lightRate: number
  lightGLA: number
  heavyRate: number
  heavyGLA: number
  heavyMinBudget1: number
  heavyStates1: string[]
  heavyMinBudget2: number
  heavyStates2: string[]
  heavyMinBudgetDoorForMF: number
  heavyMinBudgetDoor: number
  heavyBudgetDoorStates: string[]
}

export interface IRehabBudgetTypeOption6 {
  heavyRate: number
  heavyFrom: number
}

export enum RehabBudgetTypeOption {
  OPTION1 = 'opt1',
  OPTION2 = 'opt2',
  OPTION3 = 'opt3',
  OPTION4 = 'opt4',
  OPTION5 = 'opt5',
  OPTION6 = 'opt6',
}

export const rehabBudgetTypeOption: Record<RehabBudgetTypeOption, string> = {
  [RehabBudgetTypeOption.OPTION1]: 'Option 1',
  [RehabBudgetTypeOption.OPTION2]: 'Option 2',
  [RehabBudgetTypeOption.OPTION3]: 'Option 3',
  [RehabBudgetTypeOption.OPTION4]: 'Option 4',
  [RehabBudgetTypeOption.OPTION5]: 'Option 5',
  [RehabBudgetTypeOption.OPTION6]: 'Option 6',
}

export interface IRehabBudgetTypeDefinition {
  [RehabBudgetTypeOption.OPTION1]: IRehabBudgetTypeOption1
  [RehabBudgetTypeOption.OPTION2]: IRehabBudgetTypeOption2
  [RehabBudgetTypeOption.OPTION3]: IRehabBudgetTypeOption3
  [RehabBudgetTypeOption.OPTION4]: IRehabBudgetTypeOption4
  [RehabBudgetTypeOption.OPTION5]: IRehabBudgetTypeOption5
  [RehabBudgetTypeOption.OPTION6]: IRehabBudgetTypeOption6
}

export interface IRehabBudgetType {
  id: number
  // company: ICompany
  // ratesheet: IRateSheet
  programID?: number
  productType?: CommercialProductTypes
  isGeneral: boolean
  option: RehabBudgetTypeOption
  definition: IRehabBudgetTypeDefinition
  createdAt: Date
  updatedAt: Date
}

export const RatePriceAdjustmentKeysOptions: Record<RatePriceAdjustmentKeys, string> = {
  [RatePriceAdjustmentKeys.MAX_ADJUSTMENT]: 'Max Adjustment',
  [RatePriceAdjustmentKeys.LOAN_PURPOSE]: 'Loan Purpose',
  [RatePriceAdjustmentKeys.LOAN_AMOUNT]: 'Loan Amount',
  [RatePriceAdjustmentKeys.LOAN_TERM]: 'Loan Term',
  [RatePriceAdjustmentKeys.EXPERIENCE]: 'Experience',
  [RatePriceAdjustmentKeys.AIV_LTV]: 'AIV-LTV',
  [RatePriceAdjustmentKeys.LTC]: 'LTC',
  [RatePriceAdjustmentKeys.CLTV]: 'CLTV',
  [RatePriceAdjustmentKeys.FICO]: 'FICO',
  [RatePriceAdjustmentKeys.MONTHS_RESERVE]: 'Months Reserve',
  [RatePriceAdjustmentKeys.BANKRUPTCY]: 'Bankruptcy',
  [RatePriceAdjustmentKeys.FORECLOSURE]: 'Foreclosure',
  [RatePriceAdjustmentKeys.SHORT_SALE]: 'Short Sale',
  [RatePriceAdjustmentKeys.DEED_IN_LIEU]: 'Deed In Lieu',
  [RatePriceAdjustmentKeys.FORBEARANCE]: 'Forbearance',
  [RatePriceAdjustmentKeys.MORTGAGE_LATES]: 'Pay History',
  [RatePriceAdjustmentKeys.OCCUPANCY]: 'Occupancy',
  [RatePriceAdjustmentKeys.PROPERTY_TYPE]: 'Property Type',
  [RatePriceAdjustmentKeys.STATE]: 'State',
  [RatePriceAdjustmentKeys.CITIZENSHIP]: 'Citizenship',
  [RatePriceAdjustmentKeys.REHAB_BUDGET_TYPE]: 'Rehab Budget Type',
}

export enum NonDSCRCustomLLPAKeys {
  PROPERTY_TYPE = 'propertyType',
  STATE = 'state',
  CITIZENSHIP = 'citizenship',
  RURAL_PROPERTY = 'ruralProperty',
  LOAN_TERM = 'loanTerm',
  LOAN_AMOUNT = 'loanAmount',
  MONTHS_RESERVE = 'monthsReserve',
  EXPERIENCE = 'experience',
  AIV_LTV = 'aivLtv',
  ARV_LTV = 'arvLtv',
  LTC = 'ltc',
  LTP = 'ltp',
  CLTV = 'cltv',
  FICO = 'fico',
  FORECLOSURE = 'foreclosure',
  SHORT_SALE = 'shortSale',
  DEED_IN_LIEU = 'deedInLieu',
  FORBEARANCE = 'forbearance',
  BANKRUPTCY = 'bankruptcy',
  MORTGAGE_LATES = 'mortgageLates',
  REHAB_BUDGET_TYPE = 'rehabBudgetType',
}

export const NonDSCRCustomLLPAOptions: Record<NonDSCRCustomLLPAKeys, string> = {
  [NonDSCRCustomLLPAKeys.PROPERTY_TYPE]: 'Property Type',
  [NonDSCRCustomLLPAKeys.STATE]: 'State',
  [NonDSCRCustomLLPAKeys.CITIZENSHIP]: 'Citizenship',
  [NonDSCRCustomLLPAKeys.RURAL_PROPERTY]: 'Rural Property',
  [NonDSCRCustomLLPAKeys.LOAN_TERM]: 'Loan Term',
  [NonDSCRCustomLLPAKeys.LOAN_AMOUNT]: 'Loan Amount',
  [NonDSCRCustomLLPAKeys.MONTHS_RESERVE]: 'Months Reserve',
  [NonDSCRCustomLLPAKeys.EXPERIENCE]: 'Experience',
  [NonDSCRCustomLLPAKeys.AIV_LTV]: 'AIV-LTV',
  [NonDSCRCustomLLPAKeys.ARV_LTV]: 'ARV-LTV',
  [NonDSCRCustomLLPAKeys.LTC]: 'LTC',
  [NonDSCRCustomLLPAKeys.LTP]: 'LTP',
  [NonDSCRCustomLLPAKeys.CLTV]: 'CLTV',
  [NonDSCRCustomLLPAKeys.FICO]: 'FICO',
  [NonDSCRCustomLLPAKeys.FORECLOSURE]: 'Foreclosure',
  [NonDSCRCustomLLPAKeys.SHORT_SALE]: 'Short Sale',
  [NonDSCRCustomLLPAKeys.DEED_IN_LIEU]: 'Deed In Lieu',
  [NonDSCRCustomLLPAKeys.FORBEARANCE]: 'Forbearance',
  [NonDSCRCustomLLPAKeys.BANKRUPTCY]: 'Bankruptcy',
  [NonDSCRCustomLLPAKeys.MORTGAGE_LATES]: 'Pay History',
  [NonDSCRCustomLLPAKeys.REHAB_BUDGET_TYPE]: 'Rehab Budget Type',
}

export const NonDSCRCustomLLPASelectKeys: NonDSCRCustomLLPAKeys[] = [
  NonDSCRCustomLLPAKeys.PROPERTY_TYPE,
  NonDSCRCustomLLPAKeys.STATE,
  NonDSCRCustomLLPAKeys.CITIZENSHIP,
  NonDSCRCustomLLPAKeys.REHAB_BUDGET_TYPE,
  NonDSCRCustomLLPAKeys.RURAL_PROPERTY,
]

export const NonDSCRCustomRangeKeys: NonDSCRCustomLLPAKeys[] = [
  NonDSCRCustomLLPAKeys.LOAN_TERM,
  NonDSCRCustomLLPAKeys.LOAN_AMOUNT,
  NonDSCRCustomLLPAKeys.MONTHS_RESERVE,
  NonDSCRCustomLLPAKeys.EXPERIENCE,
  NonDSCRCustomLLPAKeys.AIV_LTV,
  NonDSCRCustomLLPAKeys.ARV_LTV,
  NonDSCRCustomLLPAKeys.LTC,
  NonDSCRCustomLLPAKeys.LTP,
  NonDSCRCustomLLPAKeys.CLTV,
  NonDSCRCustomLLPAKeys.FICO,
]

export const NonDSCRCustomRangeAdjustmentKeys: NonDSCRCustomLLPAKeys[] = [
  NonDSCRCustomLLPAKeys.FORECLOSURE,
  NonDSCRCustomLLPAKeys.SHORT_SALE,
  NonDSCRCustomLLPAKeys.DEED_IN_LIEU,
  NonDSCRCustomLLPAKeys.FORBEARANCE,
]

export const YesNoStringOptions = ['Yes', 'No']

export const NonDSCRCustomLLPASelectOptions: Record<string, string[] | Record<string, any>> = {
  [NonDSCRCustomLLPAKeys.PROPERTY_TYPE]: propertyTypeLabels,
  [NonDSCRCustomLLPAKeys.CITIZENSHIP]: citizenshipLabels,
  [NonDSCRCustomLLPAKeys.STATE]: {},
  [NonDSCRCustomLLPAKeys.REHAB_BUDGET_TYPE]: RehabBudgetTypesLabel,
  [NonDSCRCustomLLPAKeys.RURAL_PROPERTY]: YesNoStringOptions,
}
